import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider, AuthProvider } from "@eventsquare/uikit";

import { router } from "./router";

// // import i18n (needs to be bundled ;))
// import "@/i18n";

import "@eventsquare/uikit/css";
// import { removeCookie } from "@lib/cookies";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
